import { z } from "zod";

const requiredNameMessage = (fieldName: string) =>
  `Please enter your ${fieldName} so we can protect your purchase.`;

export const paymentDetailsSchema = z.object({
  givenName: z
    .string()
    .trim()
    .min(1, { message: requiredNameMessage("first name") }),
  familyName: z
    .string()
    .trim()
    .min(1, { message: requiredNameMessage("last name") }),
  email: z
    .string()
    .trim()
    .min(1, {
      message: "Please enter the best email for your account and security alerts.",
    })
    .email({
      message:
        "Please check that email address; we’ll use it for account and security alerts.",
    }),
});

export type PaymentDetailsValues = z.infer<typeof paymentDetailsSchema>;

export type PaymentDetailsValidity = {
  givenName: boolean;
  familyName: boolean;
  email: boolean;
};

export const emptyPaymentDetailsValidity: PaymentDetailsValidity = {
  givenName: false,
  familyName: false,
  email: false,
};

export function getPaymentDetailsValidity(
  values: Partial<Record<keyof PaymentDetailsValues, unknown>>
): PaymentDetailsValidity {
  return {
    givenName: paymentDetailsSchema.shape.givenName.safeParse(values.givenName).success,
    familyName: paymentDetailsSchema.shape.familyName.safeParse(values.familyName).success,
    email: paymentDetailsSchema.shape.email.safeParse(values.email).success,
  };
}

export function isPaymentDetailsComplete(
  validity: PaymentDetailsValidity
): boolean {
  return validity.givenName && validity.familyName && validity.email;
}
